// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { PaintTileOption, PaintTileOptionT } from '../tbs/paint-tile-option.js';
import { Position, PositionT } from '../tbs/position.js';


export class PaintTileAction implements flatbuffers.IUnpackableObject<PaintTileActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PaintTileAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPaintTileAction(bb:flatbuffers.ByteBuffer, obj?:PaintTileAction):PaintTileAction {
  return (obj || new PaintTileAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPaintTileAction(bb:flatbuffers.ByteBuffer, obj?:PaintTileAction):PaintTileAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PaintTileAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapPaintTile;
}

options(obj?:PaintTileOption):PaintTileOption|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new PaintTileOption()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

position(obj?:Position):Position|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new Position()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selectedPlayerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

static startPaintTileAction(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapPaintTile);
}

static addOptions(builder:flatbuffers.Builder, optionsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, optionsOffset, 0);
}

static addPosition(builder:flatbuffers.Builder, positionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, positionOffset, 0);
}

static addSelectedPlayerId(builder:flatbuffers.Builder, selectedPlayerId:number) {
  builder.addFieldInt32(3, selectedPlayerId, -1);
}

static endPaintTileAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): PaintTileActionT {
  return new PaintTileActionT(
    this.type(),
    (this.options() !== null ? this.options()!.unpack() : null),
    (this.position() !== null ? this.position()!.unpack() : null),
    this.selectedPlayerId()
  );
}


unpackTo(_o: PaintTileActionT): void {
  _o.type = this.type();
  _o.options = (this.options() !== null ? this.options()!.unpack() : null);
  _o.position = (this.position() !== null ? this.position()!.unpack() : null);
  _o.selectedPlayerId = this.selectedPlayerId();
}
}

export class PaintTileActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapPaintTile,
  public options: PaintTileOptionT|null = null,
  public position: PositionT|null = null,
  public selectedPlayerId: number = -1
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const options = (this.options !== null ? this.options!.pack(builder) : 0);
  const position = (this.position !== null ? this.position!.pack(builder) : 0);

  PaintTileAction.startPaintTileAction(builder);
  PaintTileAction.addType(builder, this.type);
  PaintTileAction.addOptions(builder, options);
  PaintTileAction.addPosition(builder, position);
  PaintTileAction.addSelectedPlayerId(builder, this.selectedPlayerId);

  return PaintTileAction.endPaintTileAction(builder);
}
}
